import { FEATURES } from "../data";
import { FeatureCard } from "./FeatureCard";

export const FeaturesSection = () => {
  return (
    <section className="features-section">
      <div className="features-header">
        <p className="section-label">Why it works</p>
        <h2>
          Built around the client experience - <em>enhancing your overall client
          relationship.</em>
        </h2>
      </div>

      <div className="features-grid">
        {FEATURES.map((feature) => (
          <FeatureCard key={feature.title} feature={feature} />
        ))}
      </div>
    </section>
  );
};
